import { combineReducers } from "redux";

import preVisitState from "@previsit/components/Content/reducer";
import preTravelState from "@pretravel/combinedReducer";
import workerHomeState from "@workerhome/reducers";

// Combine reducers from all 3 apps
const combinedReducers = combineReducers({
  preVisit: preVisitState,
  preTravel: preTravelState,
  workerHome: workerHomeState
});

export default combinedReducers;



// WEBPACK FOOTER //
// ./src/store/combinedReducers.js